var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.addTranslations = void 0;

var _template = _interopRequireDefault(require("lodash/template"));

var _merge = _interopRequireDefault(require("lodash/merge"));

var _templateSettings = _interopRequireDefault(require("lodash/templateSettings"));

var _en = _interopRequireDefault(require("./locales/en"));

var _de = _interopRequireDefault(require("./locales/de"));

var locales = {
  en: _en.default,
  de: _de.default
};

var addTranslations = function addTranslations(translations) {
  locales.en = (0, _merge.default)(locales.en, translations.en);
  locales.de = (0, _merge.default)(locales.de, translations.de);
};

exports.addTranslations = addTranslations;

var Translate = function Translate(key, value) {
  var locale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'de';
  var localeTranslation = locales[locale];
  var translationValue = key.split('.').reduce(function (acc, current) {
    return acc && acc[current];
  }, localeTranslation);

  if (!translationValue) {
    translationValue = process.env.NODE_ENV === 'production' ? '' : 'Translation not found';
    console.warn("No Translation found for: key: " + key + ", value: " + value + ", locale: " + locale);
  }

  if (value) {
    _templateSettings.default.interpolate = /{{([\s\S]+?)}}/g;
    var compiled = (0, _template.default)(translationValue);
    return compiled(value);
  }

  return translationValue;
};

var _default = Translate;
exports.default = _default;